import qs from 'qs';
import { IAction } from './moduleTypes';

export function createAction(name: string) {
  return (payload?: any, query?: any): IAction => ({
    type: name,
    payload,
    query,
  });
}

export function createActions(name: string) {
  const GET_ALL_REQUEST_LOADING = `${name}/GET_ALL_REQUEST_LOADING`;
  const GET_ALL_REQUEST_LOADED = `${name}/GET_ALL_REQUEST_LOADED`;
  const GET_ALL_REQUEST_FAILED = `${name}/GET_ALL_REQUEST_FAILED`;
  const GET_BY_ID_REQUEST_LOADING = `${name}/GET_BY_ID_REQUEST_LOADING`;
  const GET_BY_ID_REQUEST_LOADED = `${name}/GET_BY_ID_REQUEST_LOADED`;
  const GET_BY_ID_REQUEST_FAILED = `${name}/GET_BY_ID_REQUEST_FAILED`;
  const CREATE_REQUEST_LOADING = `${name}/CREATE_REQUEST_LOADING`;
  const CREATE_REQUEST_LOADED = `${name}/CREATE_REQUEST_LOADED`;
  const CREATE_REQUEST_FAILED = `${name}/CREATE_REQUEST_FAILED`;
  const UPDATE_REQUEST_LOADING = `${name}/UPDATE_REQUEST_LOADING`;
  const UPDATE_REQUEST_LOADED = `${name}/UPDATE_REQUEST_LOADED`;
  const UPDATE_REQUEST_FAILED = `${name}/UPDATE_REQUEST_FAILED`;
  const DELETE_REQUEST_LOADING = `${name}/DELETE_REQUEST_LOADING`;
  const DELETE_REQUEST_LOADED = `${name}/DELETE_REQUEST_LOADED`;
  const DELETE_REQUEST_FAILED = `${name}/DELETE_REQUEST_FAILED`;
  const CUSTOM_REQUEST_LOADING = `${name}/CUSTOM_REQUEST_LOADING`;
  const CUSTOM_REQUEST_LOADED = `${name}/CUSTOM_REQUEST_LOADED`;
  const CUSTOM_REQUEST_FAILED = `${name}/CUSTOM_REQUEST_FAILED`;
  const HTTP_ERRORS_DISMISSED = `${name}/HTTP_ERRORS_DISMISSED`;
  const STATE_RESET = `${name}/STATE_RESET`;

  const getAllRequestLoading = createAction(GET_ALL_REQUEST_LOADING);
  const getAllRequestLoaded = createAction(GET_ALL_REQUEST_LOADED);
  const getAllRequestFailed = createAction(GET_ALL_REQUEST_FAILED);
  const getByIdRequestLoading = createAction(GET_BY_ID_REQUEST_LOADING);
  const getByIdRequestLoaded = createAction(GET_BY_ID_REQUEST_LOADED);
  const getByIdRequestFailed = createAction(GET_BY_ID_REQUEST_FAILED);
  const createRequestLoading = createAction(CREATE_REQUEST_LOADING);
  const createRequestLoaded = createAction(CREATE_REQUEST_LOADED);
  const createRequestFailed = createAction(CREATE_REQUEST_FAILED);
  const updateRequestLoading = createAction(UPDATE_REQUEST_LOADING);
  const updateRequestLoaded = createAction(UPDATE_REQUEST_LOADED);
  const updateRequestFailed = createAction(UPDATE_REQUEST_FAILED);
  const deleteRequestLoading = createAction(DELETE_REQUEST_LOADING);
  const deleteRequestLoaded = createAction(DELETE_REQUEST_LOADED);
  const deleteRequestFailed = createAction(DELETE_REQUEST_FAILED);
  const customRequestLoading = createAction(CUSTOM_REQUEST_LOADING);
  const customRequestLoaded = createAction(CUSTOM_REQUEST_LOADED);
  const customRequestFailed = createAction(CUSTOM_REQUEST_FAILED);
  const httpErrorsDismissed = createAction(HTTP_ERRORS_DISMISSED);
  const stateReset = createAction(STATE_RESET);

  return {
    GET_ALL_REQUEST_LOADING,
    GET_ALL_REQUEST_LOADED,
    GET_ALL_REQUEST_FAILED,
    GET_BY_ID_REQUEST_LOADING,
    GET_BY_ID_REQUEST_LOADED,
    GET_BY_ID_REQUEST_FAILED,
    CREATE_REQUEST_LOADING,
    CREATE_REQUEST_LOADED,
    CREATE_REQUEST_FAILED,
    UPDATE_REQUEST_LOADING,
    UPDATE_REQUEST_LOADED,
    UPDATE_REQUEST_FAILED,
    DELETE_REQUEST_LOADING,
    DELETE_REQUEST_LOADED,
    DELETE_REQUEST_FAILED,
    CUSTOM_REQUEST_LOADING,
    CUSTOM_REQUEST_LOADED,
    CUSTOM_REQUEST_FAILED,
    HTTP_ERRORS_DISMISSED,
    STATE_RESET,
    getAllRequestLoading,
    getAllRequestLoaded,
    getAllRequestFailed,
    getByIdRequestLoading,
    getByIdRequestLoaded,
    getByIdRequestFailed,
    createRequestLoading,
    createRequestLoaded,
    createRequestFailed,
    updateRequestLoading,
    updateRequestLoaded,
    updateRequestFailed,
    deleteRequestLoading,
    deleteRequestLoaded,
    deleteRequestFailed,
    customRequestLoading,
    customRequestLoaded,
    customRequestFailed,
    httpErrorsDismissed,
    stateReset,
  };
}

export function getStateKeyFromQuery(query: Record<string, unknown>) {
  const sort = (a: any, b: any) => String(a).localeCompare(String(b));
  if (!query) {
    console.warn(
      `Received an empty query generating state keys, please check to see if the @black-bear-energy/react-common is working correctly.`
    );
  }
  return qs.stringify(query, { sort });
}
